import React from 'react';
import {Button, Divider, Input, InputNumber, message, Switch, Table} from 'antd';
import NHSelect from '../../../common/NHSelect/index';
import style from '../index.css';
import {createUuid} from "../../../../utils/NHCore";

/**
 * @author weishihuai
 * @date 2018/6/28
 * @time 16:07
 * @Description: 步骤二：表单对应字段配置
 */
export default class SecondStepForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: [],
            err: false,
            errMsg: '',
            bdzdData: []    //表单字段信息
        };
    }

    componentDidMount() {
        let initFormData = this.props.data;
        if (initFormData) {
            this.setState({formData: initFormData});
        }
    }

    validateFields = (func) => {
        let {err, formData, errMsg} = this.state;
        if (err) {
            message.error(errMsg);
        } else {
            if (!formData || formData.length === 0) {
                message.error("请至少添加一个表单字段！");
                return;
                // err = true;
            }
            for (let obj of formData) {
                if (!obj['zdmc'] || !obj['zdfl']) {
                    err = true;
                    break;
                }
            }
            if (err) {
                message.error('请填写字段名称和字段分类！');
            } else {
                func(err, formData);
            }
        }
    };

    //添加字段事件
    handleAddBtnClick = () => {
        let formData = this.state.formData;
        let zdfl = '';
        if (formData.length > 0) {
            zdfl = this.state.formData[formData.length - 1].zdfl;
            if (this.state.formData[formData.length - 1].zdmc === '' || zdfl === '') {
                message.error('请填写字段名称和字段分类！');
                return;
            }
        }

        let newFormData = {
            pkid: createUuid(),        //主键
            pxh: formData.length + 1,  //排序号
            zdmc: '',                  //字段名称
            editable: true,            //编辑模式
            zdid: '',                  //字段ID
            zdfl: zdfl,                //字段分类
            mrz: '',                   //默认值
            sfbt: '',                  //是否必填
            zdzt: ''                   //字段状态
        };
        formData.push(newFormData);
        this.setState({formData});
    };

    changeEdit = (index) => {
        let formData = this.state.formData;
        let target = formData[index];
        if (target['zdzt'] === '') {
            target['zdzt'] = '1';
        }
        if (target['sfbt'] === '') {
            target['sfbt'] = '0';
        }
        if (target['editable']) {
            if (target['zdmc'] && target['zdfl']) {
                target['editable'] = false;
            } else {
                message.error('请填写字段名称和字段分类！');
            }
        } else {
            target['editable'] = true;
        }
        this.setState({formData});
    };

    deleteData = (pkid) => {
        let formData = this.state.formData;
        let newFormData = formData.filter(record => record.pkid !== pkid);
        this.setState({formData: newFormData});
    };

    handleEditableCellChange = (value, index, key) => {
        let formData = this.state.formData;
        formData[index][key] = value;
        this.setState({formData});
    };

    render() {
        //初始化字段状态数据源
        const dataSource = [{value: '1', label: '读写'}, {value: '2', label: '只读'}, {value: '3', label: '隐藏'}];

        let columns = [
            {
                title: '排序',
                key: 'pxh',
                dataIndex: 'pxh',
                width: '60px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <InputNumber style={{margin: '-5px 0', width: '100%'}} value={text}
                                         min={1} max={99}
                                         onChange={(value) => {
                                             this.handleEditableCellChange(value, index, 'pxh')
                                         }}/>
                            : text
                    );
                }
            }, {
                title: '字段名称',
                key: 'zdmc',
                dataIndex: 'zdmc',
                width: '110px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    const filterKeys = this.state.formData.map((item) => {
                        if (record.zdid !== item.zdid) {
                            return item.zdid
                        }
                    });
                    return (
                        editable ?
                            <NHSelect style={{margin: '-5px 0', width: '80%'}}
                                      sign="zhxg_yxxt_xxcj_bdgl_zdxx"
                                      value={record.zdid} filterData={{type: 'remove', filterkeys: filterKeys}}
                                      onSelect={(value, label, option) => {
                                          this.handleEditableCellChange(value, index, 'zdid');
                                          this.handleEditableCellChange(label, index, 'zdmc')
                                      }}/>
                            : text
                    );
                },
            }, {
                title: '字段分类',
                key: 'ZDFL',
                dataIndex: 'zdfl',
                width: '100px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Input style={{margin: '-5px 0', width: '100%'}} value={text}
                                   onChange={(e) => {
                                       this.handleEditableCellChange(e.target.value, index, 'zdfl')
                                   }}/>
                            : text
                    );
                },
            }, {
                title: '字段状态',
                key: 'ZDZT',
                dataIndex: 'zdzt',
                width: '80px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <NHSelect style={{margin: '-5px 0', width: '80%'}} value={record.zdzt ? record.zdzt : '1'}
                                      dataSource={dataSource} onSelect={(value, label, option) => {
                                this.handleEditableCellChange(value, index, 'zdzt');
                                this.handleEditableCellChange(label, index, 'zd');
                                if(value === "2" || value === "3" ){
                                    this.handleEditableCellChange("0", index, 'sfbt');
                                }
                            }}/>
                            : text === '1' ? '读写' : text === '2' ? '只读' : '隐藏'
                    );
                },
            }, {
                title: '是否必填',
                key: 'SFBT',
                dataIndex: 'sfbt',
                width: '80px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    return (
                        editable && (this.state.formData[index]["zdzt"] === "1" || this.state.formData[index]["zdzt"] === "") ?
                            <Switch style={{margin: '-5px 0'}} checkedChildren="是"
                                    unCheckedChildren="否"
                                    checked={text === '1'}
                                    onChange={value => this.handleEditableCellChange(value ? '1' : '0', index, 'sfbt')}/>
                            : (text === '1' ? '是' : '否')
                    );
                },
            }, {
                title: '默认值',
                key: 'MRZ',
                dataIndex: 'mrz',
                width: '120px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Input style={{margin: '-5px 0', width: '100%'}} value={text}
                                   onChange={(e) => {
                                       this.handleEditableCellChange(e.target.value, index, 'mrz')
                                   }}/>
                            : text
                    );
                },
            }, {
                title: '操作',
                key: 'operation',
                dataIndex: 'operation',
                width: '110px',
                render: (text, record, index) => {
                    const {editable} = record;
                    return (
                        <div className={style["editable-row-operations"]}>
                            {
                                editable ?
                                    <span>
                                        <a style={{margin: 0}} onClick={() => this.changeEdit(index)}>保存</a>
                                        <Divider type={'vertical'}/>
                                        <a onClick={() => this.deleteData(record.pkid)}>取消</a>
                                    </span>
                                    : <span>
                                            <a style={{margin: 0}} onClick={() => this.changeEdit(index)}>编辑</a>
                                            <Divider type={'vertical'}/>
                                            <a onClick={() => this.deleteData(record.pkid)}>删除</a>
                                        </span>
                            }
                        </div>
                    );
                },
            }
        ];
        return <div>
            <Table rowKey={record => record.pkid} dataSource={this.state.formData} columns={columns}
                   pagination={false}/>
            <Button style={{marginTop: '5px', width: '100%'}} type="dashed" icon={'plus'}
                    onClick={this.handleAddBtnClick}>添加字段</Button>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./components/xxcj/bdgl/edit-form/step-second.js